<template>
	<el-dialog title="绑定用户" :visible="LoginBoxDialog" width="40%" @close="close">
        <div id="login-box">
			<div class="login-input">
				 <div class="title">绑定用户</div>
				 <div>
					 <div class="user">
						<img src="@/assets/user.png" alt="">
						<el-input class="user-input" v-model="username"  placeholder="请输入用户名"></el-input>
					 </div>
					 <div class="user">
						<img src="@/assets/passwords.png" alt="">
						<el-input type="password" class="user-input" v-model="password" placeholder="请输入密码"></el-input>
					 </div>
				 </div>
				<div class="footbutton">
                    <div  @click="bindUser" class="bind-user">绑定用户</div>
				</div>

				<div class="footbutton-two">
                    <div  @click="newUser"  >
						<button :disabled='disabled' style="border:none;background:#fff" class="new-user">新用户</button>
					</div>
				</div>
          
			</div>
        </div>
	</el-dialog>
</template>

<script>
	import {setCookie,getCookie,clearCookie} from '@/common/js/common'
	export default {
		name: "login-box",
		props:['LoginBoxDialog','unionid','openid','type'],
		data(){
			return {
                username:'',
                password:'',
				disabled:false
			}
		},
		methods:{
			close(){
				this.$emit('update:LoginBoxDialog',false)
				this.$router.push('/login');
			},
            //绑定用户
            bindUser(){
			if(this.username=='' && this.password==''){
					this.$message({
						type:'error',
						message:'用户名密码不能为空',
					})
					return;
				}
				let _this = this
				if(_this.type ===2 ){
					this.$post('apis/web/wx/binduser',{
						username:this.username,
						password:this.password,
						unionid:this._props.unionid
					}).then((res)=>{
						if(res){
							this.$message({
								message:'绑定成功',
								type:'success',
								onClose:()=>{
									// 储存cookie
									setCookie('user_info',encodeURIComponent(JSON.stringify(res.data)),1,'.hd199.com')
									window.uId = getCookie('user_info') ? JSON.parse(getCookie('user_info')).uid : '';
									_this.$router.push('/');
								}
							});
						}
					})
				}else if(_this._props.type ===1){
					_this.$post('apis/web/qq/binduser',{
						username:this.username,
						password:this.password,
						openid:_this._props.openid
					}).then((res)=>{
						if(res){
							this.$message({
								message:'绑定成功',
								type:'success',
								onClose:()=>{
									// 储存cookie
									setCookie('user_info',encodeURIComponent(JSON.stringify(res.data)),1,'.hd199.com')
									window.uId = getCookie('user_info') ? JSON.parse(getCookie('user_info')).uid : '';
									_this.$router.push('/');
								}
							});
						}
					})	
				}
            },
            // 新用户直接注册
            newUser(){
				let _this = this 
				this.disabled = true
				if(_this.type ==2 ){
					this.$post('apis/web/wx/register',{
						unionid:this._props.unionid,
						openid:this._props.openid
					}).then((res)=>{
						this.$message({
							message:'注册成功',
							type:'success',
							onClose:()=>{
								// 储存cookie
								setCookie('user_info',encodeURIComponent(JSON.stringify(res.data)),1,'.hd199.com')
								window.uId = getCookie('user_info') ? JSON.parse(getCookie('user_info')).uid : '';
								_this.disabled = false
								_this.$router.push('/');
							}
						});
					})
				}else if(_this._props.type ==1){
					_this.$post('apis/web/qq/register',{
						openid:_this._props.openid
					}).then((res)=>{
						this.$message({
							message:'注册成功',
							type:'success',
							onClose:()=>{
								// 储存cookie
								setCookie('user_info',encodeURIComponent(JSON.stringify(res.data)),1,'.hd199.com')
								window.uId = getCookie('user_info') ? JSON.parse(getCookie('user_info')).uid : '';
								_this.disabled = false
								_this.$router.push('/');
							}
						});
					})	
				}
            }
		}
	}
</script>

<style>
#login-box .login-box{
	display: flex;
	width: 1440px;
	margin: auto;
	margin-top: 80px;
}
#login-box .other-login{
	font-size: 14px;
	color: #7A7A7A;
	letter-spacing: 0;
	line-height: 3.75px;
	float: right;
	margin-top: 15px;
	line-height: 20px;
	display: flex;
	margin-right: 40px;
}
#login-box .login-bg img{
	width: 467px;
	height: 433px;
}
#login-box .login-bg{
	margin-left: 160px;
}
#login-box .login-input{
	width: 450px;
	height: 433px;
	border: 1px solid #F9C216 ;
	margin: auto;
}
#login-box .title{
	font-size: 28px;
	text-align: center;
	color: #F9C216 ;
	margin-top: 40px;
}
#login-box .user{
	display: flex;
	align-items: center;
	border-bottom: 1px solid #f9c216;
	height: 60px;
    width: 84%;
    margin-left: 8%;
	margin-top: 15px;	
}
#login-box .el-input__inner{
	border: none;
}
#login-box .login-footer{
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
}
.bind-user{
    font-size: 14px;
    cursor: pointer;
	background: #f9c216;
    width:70%;
    height: 50px;
    text-align: center;
    line-height: 50px;
    color: #fff;
}
.new-user{
    font-size: 14px;
    margin-right: 40px; 
    color: #f9c216;
    cursor: pointer;
}
.footbutton{
	display:flex;
	justify-content:center;
	margin-top:40px
}
.footbutton-two{
	display:flex;
	justify-content:flex-end;
	margin-top:10px
}
</style>


// WEBPACK FOOTER //
// src/components/common/LoginBox.vue